import React from 'react';
import {useSelector} from 'react-redux';

/**
 * @return {null}
 */
function Breadcrumbs () {
	const selectedLabel = useSelector(state => state.contactsGroupItemReducer.getSelectedContactsGroup);
	if (selectedLabel) {
		return (
			<div className="breadcrumbs pr-3">
				{selectedLabel.parentId ? `${selectedLabel.parentId} > ` : ''}{selectedLabel.name}
			</div>
		)
	} else {
		return null;
	}

}

export default Breadcrumbs;
